module.exports = __webpack_public_path__ + "static/media/ajax-loader.f3233732.gif";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/ajax-loader.gif
// module id = 1653
// module chunks = 1